import { useEffect, useState } from 'react';
import { getOrFetch, subscribe } from '../services/auditImageCache';

/**
 * Prefetch audit images and re-render when they arrive (e.g. open dialogs).
 */
export function useAuditImagePrefetch(auditIds, enabled = true) {
  const [, tick] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    const ids = Array.from(new Set((auditIds || []).filter(Boolean)));
    if (!ids.length) return undefined;

    ids.forEach((auditId) => {
      getOrFetch(auditId);
    });

    const unsubs = ids.map((auditId) => subscribe(auditId, () => tick((n) => n + 1)));
    return () => {
      unsubs.forEach((unsub) => unsub());
    };
  }, [enabled, auditIds]);
}

export default useAuditImagePrefetch;
